import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock, Zap, Sparkles } from 'lucide-react';
import { SectionReveal, GoldButton } from './Shared';
const CHECKOUT_URL = 'https://academiaholisticaargentina.com/cart/49059552592122:1';
export const Offer = () => {
  const includes = ['6 Módulos', '4 Bonos Premium', 'Certificado Digital', 'Acceso de por Vida', 'Descarga Ilimitada'];
  return <>
      {/* SECCIÓN 11: OFERTA ESPECIAL */}
      <SectionReveal id="oferta" className="relative" data-id="element-143">
        {/* Glow effect behind pricing */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-144"></div>

        <div id="caja-oferta" className="container mx-auto px-6 max-w-4xl relative z-10 scroll-mt-20 sm:scroll-mt-24" data-id="element-145">
          {/* Limited-time ribbon */}
          <div className="flex justify-center mb-[-1.25rem] relative z-20" data-id="element-146">
            <motion.div animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center gap-2 bg-gradient-to-r from-gold to-gold-glow text-celestial-900 font-bold text-xs sm:text-sm uppercase tracking-wider px-6 py-2.5 rounded-full shadow-[0_0_30px_rgba(212,175,55,0.5)]" data-id="element-147">
              <Sparkles className="w-4 h-4" data-id="element-148" />
              Oferta por tiempo limitado
            </motion.div>
          </div>

          <div className="bg-gradient-to-b from-celestial-800 to-celestial-900 border border-gold/40 rounded-3xl p-5 pt-9 sm:p-7 sm:pt-11 md:p-9 md:pt-12 shadow-[0_0_60px_rgba(212,175,55,0.15)] overflow-hidden relative" data-id="element-149">
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-14 h-14 border-t-2 border-l-2 border-gold/60 rounded-tl-3xl" data-id="element-150"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-2 border-r-2 border-gold/60 rounded-tr-3xl" data-id="element-151"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-2 border-l-2 border-gold/60 rounded-bl-3xl" data-id="element-152"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-2 border-r-2 border-gold/60 rounded-br-3xl" data-id="element-153"></div>

            <div className="text-center mb-5 sm:mb-7" data-id="element-154">
              <h2 className="text-xl sm:text-2xl md:text-4xl font-serif text-gold-light mb-2 sm:mb-3" data-id="element-155">
                Accedé Hoy a la Formación Completa
              </h2>
              <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-156" />
            </div>

            <div className="grid md:grid-cols-2 gap-5 sm:gap-8 items-center" data-id="element-157">
              <div className="space-y-2.5" data-id="element-158">
                <h3 className="text-lg font-serif text-gold mb-3" data-id="element-159">Incluye:</h3>
                {includes.map((item, idx) => <div key={idx} className="flex items-center space-x-3" data-id="element-160">
                    <div className="bg-gold/20 p-1 rounded-full" data-id="element-161">
                      <Check className="w-3.5 h-3.5 text-gold" data-id="element-162" />
                    </div>
                    <span className="text-indigo-100/90 font-medium text-base" data-id="element-163">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div id="pago" className="relative scroll-mt-24 bg-celestial-900/90 border-2 border-gold/40 rounded-2xl p-4 sm:p-6 text-center flex flex-col items-center justify-center shadow-[0_0_40px_rgba(212,175,55,0.12)] overflow-hidden" data-id="element-164">
                {/* Discount badge */}
                <div className="absolute -top-px -right-px bg-gradient-to-br from-gold to-gold-glow text-celestial-900 font-bold text-xs sm:text-sm px-3 py-1 rounded-bl-2xl rounded-tr-2xl shadow-lg" data-id="element-165">
                  -67% OFF
                </div>

                {/* Inner glow */}
                <div className="absolute inset-0 bg-gold/5 blur-3xl pointer-events-none" data-id="element-166"></div>

                <p className="relative text-indigo-100/60 text-xs sm:text-sm" data-id="element-167">
                  Precio Regular
                </p>
                <p className="relative text-indigo-100/50 line-through text-xl mb-3" data-id="element-168">
                  $59.990
                </p>

                <div className="relative flex flex-col items-center mb-1" data-id="element-169">
                  <span className="text-xs sm:text-sm text-gold-light font-medium uppercase tracking-widest mb-0.5" data-id="element-170">
                    Hoy solo
                  </span>
                  <span className="text-4xl sm:text-5xl md:text-6xl font-serif text-gold font-bold leading-none drop-shadow-[0_0_20px_rgba(212,175,55,0.4)]" data-id="element-171">
                    $19.990
                  </span>
                  <span className="text-[11px] sm:text-xs text-indigo-100/50 mt-1.5" data-id="element-172">
                    Pago único · Sin suscripciones
                  </span>
                </div>

                {/* Urgency */}
                <div className="relative flex items-center justify-center gap-2 my-3 text-xs sm:text-sm text-gold-light" data-id="element-173">
                  <span className="relative flex h-2.5 w-2.5" data-id="element-174">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-75" data-id="element-175"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" data-id="element-176"></span>
                  </span>
                  El precio promocional finaliza pronto
                </div>

                <motion.div animate={{
                scale: [1, 1.03, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="relative w-full mb-3" data-id="element-177">
                  <GoldButton href={CHECKOUT_URL} target="_blank" className="w-full" data-id="element-178">
                    QUIERO ACCEDER AHORA
                  </GoldButton>
                </motion.div>

                <div className="relative flex items-center justify-center gap-4 mb-3 text-xs text-indigo-100/60" data-id="element-179">
                  <span className="flex items-center gap-1.5" data-id="element-180">
                    <Lock className="w-3.5 h-3.5 text-gold" data-id="element-181" /> Pago seguro
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-182">
                    <Zap className="w-3.5 h-3.5 text-gold" data-id="element-183" /> Acceso inmediato
                  </span>
                </div>

                <div className="relative flex items-center justify-center space-x-2 text-indigo-100/70 text-xs sm:text-sm bg-celestial-800/50 py-2 px-3 rounded-full border border-gold/20 w-full" data-id="element-184">
                  <ShieldCheck className="w-4 h-4 text-gold flex-shrink-0" data-id="element-185" />
                  <span data-id="element-186">
                    <strong data-id="element-187">Garantía de 7 días</strong> — Probá sin riesgo.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionReveal>

      {/* CTA FINAL */}
      <SectionReveal className="bg-celestial-900 border-t border-gold/10 pb-10" data-id="element-188">
        <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-serif text-gold-light mb-6" data-id="element-190">
            Comenzá Hoy Tu Camino en los Registros Akáshicos
          </h2>
          <p className="text-lg text-indigo-100/80 mb-10 font-light" data-id="element-191">
            Descubrí una herramienta de autoconocimiento, comprensión y
            crecimiento personal que podrá acompañarte durante toda la vida.
          </p>
          <GoldButton href={CHECKOUT_URL} target="_blank" data-id="element-192">
            QUIERO ACCEDER AHORA
          </GoldButton>
        </div>
      </SectionReveal>

      {/* FOOTER */}
      <footer className="bg-[#0f0c20] py-8 border-t border-gold/5" data-id="element-193">
        <div className="container mx-auto px-6 text-center" data-id="element-194">
          <h3 className="text-gold-light font-serif text-xl mb-2" data-id="element-195">
            Academia Holística Argentina
          </h3>
          <p className="text-indigo-100/40 text-sm" data-id="element-196">
            © {new Date().getFullYear()} Academia Holística Argentina. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>
    </>;
};